<div class="dialog-heading" mat-dialog-title>
    <span>{{ editing ? 'Editar contenido' : 'Crear contenido' }}</span>
    <h2>{{ data.config.label }}</h2>
</div>
<mat-dialog-content>
    <form [formGroup]="form" class="row-dialog-form">
        <ng-container *ngFor="let field of data.config.fields">
            <ng-container [ngSwitch]="field.type">
                <mat-form-field *ngSwitchCase="'textarea'" appearance="outline" class="full-width">
                    <mat-label>{{ field.label }}{{ field.required ? ' *' : '' }}</mat-label>
                    <textarea matInput rows="3" [formControlName]="field.name"></textarea>
                </mat-form-field>

                <mat-form-field *ngSwitchCase="'select'" appearance="outline" class="full-width">
                    <mat-label>{{ field.label }}{{ field.required ? ' *' : '' }}</mat-label>
                    <mat-select [formControlName]="field.name">
                        <mat-option *ngFor="let option of field.options" [value]="option.value">{{ option.label }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field *ngSwitchCase="'date'" appearance="outline" class="full-width">
                    <mat-label>{{ field.label }}{{ field.required ? ' *' : '' }}</mat-label>
                    <input matInput type="date" [formControlName]="field.name">
                </mat-form-field>

                <mat-form-field *ngSwitchCase="'number'" appearance="outline" class="full-width">
                    <mat-label>{{ field.label }}{{ field.required ? ' *' : '' }}</mat-label>
                    <input matInput type="number" [formControlName]="field.name">
                </mat-form-field>

                <mat-form-field *ngSwitchCase="'password'" appearance="outline" class="full-width">
                    <mat-label>{{ field.label }}{{ editing ? '' : ' *' }}</mat-label>
                    <input matInput type="password" autocomplete="new-password" [formControlName]="field.name">
                    <mat-hint *ngIf="editing">Dejar vacío para conservar la actual</mat-hint>
                </mat-form-field>

                <mat-form-field *ngSwitchCase="'url'" appearance="outline" class="full-width">
                    <mat-label>{{ field.label }}{{ field.required ? ' *' : '' }}</mat-label>
                    <input matInput type="url" placeholder="https://..." [formControlName]="field.name">
                </mat-form-field>

                <mat-form-field *ngSwitchDefault appearance="outline" class="full-width">
                    <mat-label>{{ field.label }}{{ field.required ? ' *' : '' }}</mat-label>
                    <input matInput [formControlName]="field.name">
                </mat-form-field>

                <div *ngSwitchCase="'image'" class="image-field">
                    <span class="image-field-label">{{ field.label }}{{ field.required ? ' *' : '' }}</span>
                    <div class="image-field-body">
                        <img *ngIf="preview(fileId(field)) | async as url" [src]="url" alt="Vista previa" class="image-preview">
                        <button type="button" mat-raised-button (click)="fileInput.click()" [disabled]="uploadingField !== null">
                            {{ uploadingField === field.name ? 'Subiendo…' : (fileId(field) ? 'Cambiar imagen' : 'Subir imagen') }}
                        </button>
                        <input #fileInput hidden type="file" accept="image/*" (change)="onFileSelected(field, $event)">
                        <button *ngIf="fileId(field)" type="button" mat-stroked-button (click)="clearImage(field)">Quitar imagen</button>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-stroked-button class="dialog-button" (click)="onCancel()">Cancelar</button>
    <button *ngIf="editing" mat-stroked-button class="dialog-button delete-button" color="warn" (click)="onDelete()"><i class="fas fa-trash" aria-hidden="true"></i> Eliminar</button>
    <button mat-raised-button class="dialog-button save-button" color="primary" [disabled]="form.invalid || uploadingField !== null || hasMissingRequiredImage()" (click)="onSave()"><i class="fas fa-check" aria-hidden="true"></i> Guardar</button>
</mat-dialog-actions>
